<template>
  <div
    class="floorCard"
    :class="{'activeRoom' : (currentRoomIndex !== null)}"
  >
    <div class="floorCardHead">
      <h3>{{ this.floor.title }}</h3>
      <div
        v-if="this.currentRoomIndex !== null"
        class="cardHeadRoom"
      >
        <h3>{{ '/' }}</h3>
        <h3>{{ roomTitle }}</h3>
      </div>
    </div>
    <div class="floorCardContent" ref="cardContent">
      <RoomCard
        v-for="(room, roomIndex) in this.floor.rooms"
        :key="roomIndex"
        :room="room"
        :active="currentFloorIndex === index && currentRoomIndex === room.id"
      />
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { setTimeout } from 'timers';
import RoomCard from './RoomCard.vue';

export default {
  components: {
    RoomCard,
  },
  props: {
    floor: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['currentFloorIndex', 'currentRoomIndex', 'currentRoomTitle']),
    isActive() {
      return this.currentFloorIndex === this.index;
    },
    roomTitle() {
      return (this.currentRoomIndex === null ? '' : this.currentRoomTitle);
    },
  },
  methods: {
    resetScroll() {
      this.updateTimeOut = setTimeout(() => {
        this.$refs.cardContent.scrollTop = 0;
      }, 500);
    },
  },
  watch: {
    isActive(newValue) {
      if (!newValue) {
        this.resetScroll();
      }
    },
  },
};
</script>

<style lang="scss">
.floorCard{
  position: relative;
  width: 100%;
  padding: 0 10vw 0 calc(10vw - 5px);
  overflow: hidden;
  box-sizing: border-box;
  background-color: var(--main-background-color);
  transform: translateY(0);
  transition: transform .3s ease;

  .floorCardHead {
    height: 9vh;
    height: calc(var(--vh, 1vh) * 9);
    /* text-transform: uppercase; */
    text-align: center;
    margin: auto;
    /* border-bottom: 2px solid var(--main-decoration-light-color); */
    box-sizing: border-box;

    display: flex;
    justify-content: center;
    align-items: center;

    .cardHeadRoom {
      display: none;
    }

    h3 {
      font-size: 1.1em;
      /* font-weight: normal; */
      margin: 0;
      padding: 0;
      color: var(--main-elements-color);
    }
  }
  .floorCardContent {
    height: 68vh;
    height: calc(var(--vh, 1vh) * 68);
    text-align: left;
    overflow-y: scroll;
    box-sizing: border-box;
    transition: height .3s ease;
  }

  &.activeRoom {
    transform: translateY(-9vh);
    transform: translateY(calc(var(--vh, 1vh) * -9));

    .floorCardHead {
      border: none;
    }
    .floorCardContent {
      height: 77vh;
      height: calc(var(--vh, 1vh) * 77);
    }
  }
}
@media (min-width : 400px) {
  .floorCard{
    padding: 0 40px;
  }
}
@media only screen and (orientation : portrait)
 and (min-aspect-ratio: 4/9)
 and (max-height : 700px) {
   .floorCard{
     .floorCardHead {
       h3 {
         padding-top: 2vh;
         padding-top: calc(var(--vh, 1vh) * 2);
       }
     }
   }
}
@media only screen and (orientation : landscape) {
  .floorCard{
    display: flex;
    padding: 0;

    .floorCardHead {
      flex: 1;
      height: 77vh;
      height: calc(var(--vh, 1vh) * 77);
      min-width: 38vw;
      border-bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      h3 {
        /* font-size: .9em; */
        padding-top: 7px;
      }
      .cardHeadRoom {
        display: block;
      }
    }

    .floorCardContent {
      flex: 2;
      height: 77vh;
      height: calc(var(--vh, 1vh) * 77);
      padding-top: 4vh;
      padding-top: calc(var(--vh, 1vh) * 4);
    }
    @media (min-height : 700px) {
      .floorCardContent {
        /* padding-top: 10vh;
        padding-top: calc(var(--vh, 1vh) * 10); */
        display: flex;
        flex-direction: column;
        align-content: stretch;
        align-items: stretch;
        padding-right: 10vw;
      }
      .roomCard {
        flex: 1;
      }
    }

    &.activeRoom {
      transform: translateY(0);
      .floorCardContent {
        /* height: 75vh;
        height: calc(var(--vh, 1vh) * 75); */
      }
    }
  }
}
</style>
